/**
 * @generated SignedSource<<52db8a32496a51af67acfab3ae236a7b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersGetTypeNameNode$data = {
  readonly __typename: string;
  readonly entityId: string;
  readonly parentSection?: string | null | undefined;
  readonly topicTypes?: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckCanShowInPlusPlatformArticle" | "helpersCheckIsPlusArticle">;
  readonly " $fragmentType": "helpersGetTypeNameNode";
};
export type helpersGetTypeNameNode$key = {
  readonly " $data"?: helpersGetTypeNameNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersGetTypeNameNode">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersGetTypeNameNode"
};

(node as any).hash = "45a4693ddd9c0ce6ee28119970f45707";

export default node;
